var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaudiarabia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78262 14.3478C6.78262 15.2122 7.4834 15.913 8.34783 15.913H13.0435C13.0435 16.6334 13.6275 17.2174 14.3478 17.2174H15.913C16.6334 17.2174 17.2174 16.6334 17.2174 15.913V14.3478H6.78262Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3478 6.78262V10.4348C17.3478 11.0102 16.8797 11.4783 16.3043 11.4783V13.0435C17.7428 13.0435 18.913 11.8732 18.913 10.4348V6.78262H17.3478Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13045 10.4348C6.13045 11.0102 5.66236 11.4783 5.08697 11.4783V13.0435C6.52542 13.0435 7.69565 11.8732 7.69565 10.4348V6.78262H6.13045V10.4348Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6.78262H16.5652V10.4348H15V6.78262Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6522 8.86955C12.6522 9.01341 12.5351 9.13041 12.3913 9.13041C12.2475 9.13041 12.1305 9.01336 12.1305 8.86955V6.78258H10.5652V8.86955C10.5652 9.01341 10.4482 9.13041 10.3044 9.13041C10.1606 9.13041 10.0435 9.01336 10.0435 8.86955V6.78258H8.47828V8.86955C8.47828 9.87647 9.29747 10.6957 10.3044 10.6957C10.6922 10.6957 11.0518 10.5738 11.3479 10.3668C11.6439 10.5737 12.0036 10.6957 12.3914 10.6957C12.4695 10.6957 12.5462 10.6902 12.6217 10.6806C12.5108 11.1375 12.0993 11.4782 11.6087 11.4782V13.0434C13.0472 13.0434 14.2174 11.8732 14.2174 10.4347V8.86955V6.78258H12.6522V8.86955H12.6522Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47828 11.4783H10.8261V13.0435H8.47828V11.4783Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaudiarabia);
export default __webpack_public_path__ + "static/media/saudiarabia.ac0577b7413f14eb8d6cb89aeb12f863.svg";
export { ForwardRef as ReactComponent };